export const TOGGLE_COMPONENT = 'TOGGLE_COMPONENT'
export const TOGGLE_STATIC = 'TOGGLE_STATIC'



// WEBPACK FOOTER //
// ./styleguide/constants/ActionTypes.js